<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div>
      <NavBarOnly></NavBarOnly>
      <div class="conteudo cor-secundaria-bg" style="position: unset;">
        <logo-empresa></logo-empresa>
        <h5>{{ $t('realize_seu_cadastro') }}</h5>
        <div class="row" style="width: 100% !important; margin-bottom: 0px;">
          <div class="input-field col s12" style="background-color: white;">
            <input id="email" type="email" class="validate" v-model="email">
            <label for="email">{{ $t('informe_seu_email') }}</label>
          </div>
          <div class="input-field col s12" style="background-color: white;">
            <input id="nome" type="text" class="validate" v-model="nome">
            <label for="nome">{{ $t('informe_seu_nome_e_sobrenome') }}</label>
          </div>
          <div class="input-field col s12" style="background-color: white;">
            <the-mask id="telefone" v-model="telefone" type="tel" required :masked="true"
                      :mask="['(##) ####-####','(##) #####-####']" :placeholder="$t('seu_telefone')"/>
          </div>
        </div>
        <p>
          {{ $t('termos_de_servico_aviso') }}
        </p>
        <div class="btn waves-effect waves-light cor-primaria-bg" @click="ConcluirCadastro()" style="padding: 0; width: 100%">
          <div class="">
            <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">
              {{ $t('concluir_cadastro') }}
            </div>
          </div>
       </div>
       <div style="height: 400px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import NavBarOnly from "../../Widgets/NavBarOnly";
import LogoEmpresa from "../../Widgets/LogoEmpresa";

export default {
  name: "NovoCadastro",
  components: {
    LogoEmpresa,
    NavBarOnly,
    Loading
  },
  data() {
    return {
      nome:"",
      email:"",
      telefone:"",
      isLoading: false,
      fullPage: true
    };
  },
  mounted() {
    $("body").css({"overflow":"unset"});
    window.scrollTo(0, 0);
  },
  methods: {
    ConcluirCadastro(){
      if(this.nome == "" || this.email == "" || this.telefone == ""){
        alert("Preencha todos os campos");
        return;
      }
      this.isLoading = true;
      axios.post(this.$store.state.apiUrl + "cliente/cadastrar", {
        nome: this.nome,
        email: this.email,
        telefone: this.telefone
      }).then(response => {
        this.isLoading = false;
        this.$router.push("/" + this.$store.state.empresa_url + "/validar-codigo?email=" + this.email);
        alert("Cadastro realizado com sucesso! Enviamos um código de validação para seu e-mail.");
      }).catch(error => {
        this.isLoading = false;
        if(error.response.data.message != undefined && error.response.data.message != null && error.response.data.message != ""){
          alert(error.response.data.message);
        }else{
          alert("Erro ao realizar o cadastro");
        }
      });
    }
  }
};
</script>

<style scoped>
  @import '../../../assets/css/conteudo-splash.css';
</style>



// WEBPACK FOOTER //
// src/components/Paginas/AreaCliente/NovoCadastro.vue